(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      var tabs = document.querySelectorAll('.tab-icon');
      var contents = document.querySelectorAll('.tab-content');

      // Show the first content by default
      document.querySelector('.tab-content.active').style.display = 'block';

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var tabId = this.getAttribute('data-tab');

          // Remove active class from all tabs and hide all content
          tabs.forEach(function(t) {
            t.classList.remove('active');
          });
          contents.forEach(function(content) {
            content.style.display = 'none';
            content.classList.remove('active');
          });

          // Add active class to the clicked tab and show its content
          this.classList.add('active');
          var contentToShow = document.getElementById('tab-content-' + tabId);
          contentToShow.style.display = 'block';
          contentToShow.classList.add('active');
        });
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tab"] && !Shopify.designMode) return;
  try {
    
tabs = document.querySelectorAll('.custom-tab');
tabContents = document.querySelectorAll('.custom__tab-content');

tabs.forEach(function(tab) {
  tab.addEventListener('click', function() {
    contentId = this.dataset.contentId;
    content = document.getElementById(contentId);

    tabContents.forEach(function(content) {
      content.classList.remove('active');
    });

    tabs.forEach(function(tab) {
      tab.classList.remove('active');
    });

    this.classList.add('active');
    content.classList.add('active');
  });
});

// Accordion functionality
var acc = document.getElementsByClassName("accordion");
for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["detail-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
      // Select all tabs and tab content elements
      const tabs = document.querySelectorAll('.custom-tab');
      const tabContents = document.querySelectorAll('.custom__tab-content');

      // Function to remove 'active' class from all tabs and tab contents
      function removeActiveClasses() {
          tabContents.forEach(function(content) {
              content.classList.remove('active');
          });
          tabs.forEach(function(tab) {
              tab.classList.remove('active');
          });
      }

      // Function to activate the first tab and its content
      function activateFirstTab() {
          tabs[0].classList.add('active');
          tabContents[0].classList.add('active');
      }

      // Set the first tab as active by default
      activateFirstTab();

      // Add click event listeners to each tab
      tabs.forEach(function(tab) {
          tab.addEventListener('click', function() {
              const contentId = this.dataset.contentId;
              const content = document.getElementById(contentId);

              // Remove active classes from all tabs and contents
              removeActiveClasses();

              // Add active class to the clicked tab and its corresponding content
              this.classList.add('active');
              content.classList.add('active');
          });
      });
  });



  document.addEventListener("DOMContentLoaded", function () {
    const titles = document.querySelectorAll('.accordion-title');

    function setAccordionIcon(iconEl, isOpen) {
      if (!iconEl) return;
      const iconI = iconEl.querySelector('i');
      if (iconI) {
        iconI.classList.toggle('fa-plus', !isOpen);
        iconI.classList.toggle('fa-minus', isOpen);
      } else {
        iconEl.textContent = isOpen ? '-' : '+';
      }
    }

    titles.forEach(function (title) {
      title.addEventListener('click', function () {
        const item = this.parentElement;
        if (!item || !item.classList.contains('accordion-item')) return;

        const content = this.nextElementSibling;
        if (!content || !content.classList.contains('accordion-content')) return;

        const icon = this.querySelector('.accordion-icon');
        const isActive = item.classList.contains('active');

        const siblingContainer = item.parentElement;
        if (siblingContainer) {
          siblingContainer.querySelectorAll(':scope > .accordion-item').forEach(function (otherItem) {
            if (otherItem === item) return;
            otherItem.classList.remove('active');
            const otherContent = otherItem.querySelector(':scope > .accordion-content');
            const otherIcon = otherItem.querySelector(':scope > .accordion-title .accordion-icon');
            if (otherContent) {
              otherContent.style.display = 'none';
            }
            setAccordionIcon(otherIcon, false);
          });
        }

        item.classList.toggle('active', !isActive);
        content.style.display = isActive ? 'none' : 'block';
        setAccordionIcon(icon, !isActive);
      });
    });
  });


  document.addEventListener('DOMContentLoaded', function () {
      // Select all accordion items
      const accordionItems = document.querySelectorAll('.accordion-item-in');

      // Loop through each accordion item
      accordionItems.forEach(function (item) {
          const title = item.querySelector('.accordion-title-in');
          const content = item.querySelector('.accordion-content-in');
          const icon = item.querySelector('.accordion-icon-in');

          // Add click event listener to the title
          title.addEventListener('click', function () {
              // Check if the content is currently displayed
              const isOpen = content.style.display === 'block';

              // Close all other accordion items
              accordionItems.forEach(function (otherItem) {
                  const otherContent = otherItem.querySelector('.accordion-content-in');
                  const otherIcon = otherItem.querySelector('.accordion-icon-in');
                  otherContent.style.display = 'none';
                  otherIcon.textContent = '+';
              });

              // Toggle the clicked accordion item
              if (isOpen) {
                  content.style.display = 'none';
                  icon.textContent = '+';
              } else {
                  content.style.display = 'block';
                  icon.textContent = '-';
              }
          });
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  const headings = document.querySelectorAll('.grid .footer-block__heading');

  const handleCollapse = (heading) => {
    const content = heading.nextElementSibling;

    if (heading.classList.contains('block-collapsed')) {
      heading.classList.remove('block-collapsed');
      heading.setAttribute('aria-expanded', 'true');
      content.style.display = 'block'; // or any other preferred display property
    } else {
      heading.classList.add('block-collapsed');
      heading.setAttribute('aria-expanded', 'false');
      content.style.display = 'none';
    }
  };

  headings.forEach((heading, index) => {
    heading.classList.add('block-collapsed');
    heading.setAttribute('role', 'button');
    heading.setAttribute('aria-expanded', 'false');
    heading.setAttribute('tabindex', '0');

    const content = heading.nextElementSibling;
    if (!content) return;
    content.setAttribute('id', `footer-block-index-${index}`);
    heading.setAttribute('aria-controls', `footer-block-index-${index}`);

    heading.addEventListener('click', () => {
      handleCollapse(heading);
    });

    heading.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        handleCollapse(heading);
      }
    });
  });
});

var footerExternalLink = document.querySelector("#footer-block-index-1 li:last-child a");
if (footerExternalLink) {
  footerExternalLink.setAttribute("target", "_blank");
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
 window.DaburShop.whenSlickReady(function () {
    jQuery(function () {
    var slider = jQuery('.responsive');
    if (!slider.length || slider.hasClass('slick-initialized')) return;
    slider.slick({
      slidesToShow: 3.2,
      infinite: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
           slidesToShow: 50,
            dots: false
          }
        }
      ]
    });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mansoon"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    var slider = $('.product-slider');
    if (!slider.length || slider.hasClass('slick-initialized')) return;
    slider.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 100,
            dots: false
          }
        }
      ]
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multiple-category-icon"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.currentScript.closest('.shopify-section');
  var container = section.querySelector('.mc-strip__track');

  if (!container) return;

  var isPaused = false;
  var speed = 0.5;

  // Clone items for infinite scroll
  var items = Array.from(container.children);

  items.forEach(function(item) {
    container.appendChild(item.cloneNode(true));
  });

  function scrollLoop() {

    if (!isPaused) {
      container.scrollLeft += speed;

      if (container.scrollLeft >= container.scrollWidth / 2) {
        container.scrollLeft = 0;
      }
    }

    requestAnimationFrame(scrollLoop);
  }

  scrollLoop();

  // Desktop hover pause
  container.addEventListener('mouseenter', function() {
    isPaused = true;
  });

  container.addEventListener('mouseleave', function() {
    isPaused = false;
  });

  // Mobile touch pause
  container.addEventListener('touchstart', function() {
    isPaused = true;
  });

  container.addEventListener('touchend', function() {
    setTimeout(function() {
      isPaused = false;
    }, 800);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundler"] && !Shopify.designMode) return;
  try {
    
Shopify.blockRefresh = {
  onSectionLoad: function() {},
  onSectionUnload: function() {},
  onBlockSelect: function() {},
  onBlockDeselect: function() {},
  onLoad: function() {}
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
(function() {
  var container = document.currentScript.closest('.shopify-section').querySelector('.horizontal-feature-strip__inner');
  if (!container) return;

  var isHovering = false;
  var scrollSpeed = 0.5;

  var items = Array.prototype.slice.call(container.children);

  items.forEach(function(item) {
    var clone = item.cloneNode(true);
    container.appendChild(clone);
  });

  function autoScroll() {

    if (!isHovering) {
      container.scrollLeft += scrollSpeed;

      var totalWidth = container.scrollWidth / 2;

      if (container.scrollLeft >= totalWidth) {
        container.scrollLeft = 0;
      }
    }

    requestAnimationFrame(autoScroll);
  }

  autoScroll();

  container.addEventListener('mouseenter', function() {
    isHovering = true;
  });

  container.addEventListener('mouseleave', function() {
    isHovering = false;
  });

  var touchTimeout;

  container.addEventListener('touchstart', function() {
    isHovering = true;
    clearTimeout(touchTimeout);
  });

  container.addEventListener('touchend', function() {
    clearTimeout(touchTimeout);

    touchTimeout = setTimeout(function() {
      isHovering = false;
    }, 800);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-split-section"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sectionId = '{{ section.id }}';
    var slider = document.getElementById('review-slider-' + sectionId);
    if (!slider) return;

    var isHovering = false;
    var isDragging = false;
    var scrollSpeed = 0.3;
    var animationFrameId = null;

    // Duplicate cards for seamless loop
    var cards = Array.prototype.slice.call(slider.children);
    if (cards.length === 0) return;

    cards.forEach(function(card) {
      var clone = card.cloneNode(true);
      slider.appendChild(clone);
    });

    function autoScroll() {
      if (!isHovering && !isDragging) {
        slider.scrollLeft += scrollSpeed;
        
        var totalWidth = slider.scrollWidth / 2;
        if (slider.scrollLeft >= totalWidth) {
          slider.scrollLeft = 0;
        }
      }
      animationFrameId = requestAnimationFrame(autoScroll);
    }

    // Start auto-scroll
    autoScroll();

    // Pause on hover (desktop)
    slider.addEventListener('mouseenter', function() {
      isHovering = true;
    });

    slider.addEventListener('mouseleave', function() {
      isHovering = false;
    });

    // Handle manual drag/scroll
    var startX = 0;
    var scrollLeft = 0;

    slider.addEventListener('mousedown', function(e) {
      isDragging = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      slider.style.cursor = 'grabbing';
    });

    slider.addEventListener('mouseleave', function() {
      isDragging = false;
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('mouseup', function() {
      isDragging = false;
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      e.preventDefault();
      var x = e.pageX - slider.offsetLeft;
      var walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    });

    // Touch support for mobile
    var touchStartX = 0;
    var touchScrollLeft = 0;

    slider.addEventListener('touchstart', function(e) {
      isDragging = true;
      touchStartX = e.touches[0].pageX - slider.offsetLeft;
      touchScrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('touchend', function() {
      isDragging = false;
    });

    slider.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      var x = e.touches[0].pageX - slider.offsetLeft;
      var walk = (x - touchStartX) * 2;
      slider.scrollLeft = touchScrollLeft - walk;
    });

    // Cleanup on section unload
    if (typeof window.addEventListener !== 'undefined') {
      window.addEventListener('beforeunload', function() {
        if (animationFrameId) {
          cancelAnimationFrame(animationFrameId);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
